import React, { useState, useEffect } from "react";
import axios from "axios";
import ModalSolicitacoesAditivos from "./ModalSolicitacoesAditivos";

function ModalSolicitarAditivo({ projetoId, onClose }) {
  // --- Estados Simplificados ---
  const [tipo, setTipo] = useState("valor");
  const [valor, setValor] = useState("");
  const [prazo, setPrazo] = useState("");
  const [etapa, setEtapa] = useState("");
  const [descricao, setDescricao] = useState("");
  const [idSecretaria, setIdSecretaria] = useState("");
  const [idOrcamento, setIdOrcamento] = useState("");

  // Dados
  const [secretarias, setSecretarias] = useState([]);
  const [orcamentos, setOrcamentos] = useState([]);

  // Controle de UI
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState({ texto: "", tipo: "" }); // tipo: 'success' ou 'danger'
  const [showHistorico, setShowHistorico] = useState(false);

  // --- Buscas de Dados ---
  useEffect(() => {
    const token = localStorage.getItem("Token");
    axios
      .get("/api/secretaria", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setSecretarias(res.data.Result || []))
      .catch(() => console.error("Erro ao buscar secretarias"));
  }, []);

  useEffect(() => {
    if (!idSecretaria || tipo !== "valor") {
      setOrcamentos([]);
      return;
    }
    const token = localStorage.getItem("Token");
    axios
      .get(`/api/orcamento/secretaria/${idSecretaria}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setOrcamentos(res.data))
      .catch(() => setOrcamentos([]));
  }, [idSecretaria, tipo]);

  // --- Envio ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensagem({ texto: "", tipo: "" });

    // Validação simples
    if (!descricao) {
      setMensagem({ texto: "A justificativa é obrigatória.", tipo: "danger" });
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("Token");
      const userId = localStorage.getItem("UserId");

      const body = {
        id_projeto: projetoId,
        id_secretaria: parseInt(idSecretaria),
        tipo,
        valor: tipo === "valor" ? parseFloat(valor) : null,
        prazo: tipo === "prazo" ? parseInt(prazo) : null,
        etapa: tipo === "prazo" ? parseInt(etapa) : null,
        id_orcamento: tipo === "valor" ? parseInt(idOrcamento) : null,
        descricao_pedido: descricao,
        criado_por: parseInt(userId),
      };

      await axios.post("/api/aditivos", body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMensagem({
        texto: "Solicitação enviada com sucesso!",
        tipo: "success",
      });
      setTimeout(onClose, 1500);
    } catch (error) {
      setMensagem({ texto: "Erro ao enviar solicitação.", tipo: "danger" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow rounded-3 border-0">
          {/* Cabeçalho Limpo */}
          <div className="modal-header bg-white border-bottom-0">
            <h5 className="modal-title fw-bold text-dark">Solicitar Aditivo</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body p-4">
            <form onSubmit={handleSubmit}>
              {/* Seleção de Tipo */}
              <div className="mb-3">
                <label className="form-label fw-bold small text-muted">
                  TIPO DO PEDIDO
                </label>
                <select
                  className="form-select"
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                >
                  <option value="valor">Financeiro (Valor)</option>
                  <option value="prazo">Cronograma (Prazo)</option>
                </select>
              </div>

              <hr className="text-muted opacity-25" />

              {/* Campos Dinâmicos: VALOR */}
              {tipo === "valor" && (
                <>
                  <div className="mb-3">
                    <label className="form-label">Valor (R$)</label>
                    <input
                      type="number"
                      className="form-control"
                      step="0.01"
                      placeholder="0,00"
                      value={valor}
                      onChange={(e) => setValor(e.target.value)}
                      required
                    />
                  </div>
                </>
              )}

              {/* Campos Dinâmicos: PRAZO */}
              {tipo === "prazo" && (
                <div className="row">
                  <div className="col-6 mb-3">
                    <label className="form-label">Dias Adicionais</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Ex: 30"
                      value={prazo}
                      onChange={(e) => setPrazo(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label">Etapa</label>
                    <select
                      className="form-select"
                      value={etapa}
                      onChange={(e) => setEtapa(e.target.value)}
                      required
                    >
                      <option value="">Selecione...</option>
                      {[1, 2, 3, 4, 5, 6].map((n) => (
                        <option key={n} value={n}>
                          Etapa {n}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* Secretaria (Comum) */}
              <div className="mb-3">
                <label className="form-label">Secretaria Responsável</label>
                <select
                  className="form-select"
                  value={idSecretaria}
                  onChange={(e) => setIdSecretaria(e.target.value)}
                  required
                >
                  <option value="">Selecione...</option>
                  {secretarias.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.nomesecretaria}
                    </option>
                  ))}
                </select>
              </div>

              {/* Orçamento (Apenas Valor) */}
              {tipo === "valor" && (
                <div className="mb-3">
                  <label className="form-label">Fonte de Recurso</label>
                  <select
                    className="form-select"
                    value={idOrcamento}
                    onChange={(e) => setIdOrcamento(e.target.value)}
                    disabled={!idSecretaria || orcamentos.length === 0}
                    required
                  >
                    {orcamentos.length === 0 ? (
                      <option value="">Sem orçamento disponível</option>
                    ) : (
                      orcamentos.map((o) => (
                        <option key={o.id} value={o.id}>
                          {o.classificacao_institucional} - R${" "}
                          {parseFloat(o.valor).toLocaleString("pt-BR")}
                        </option>
                      ))
                    )}
                  </select>
                </div>
              )}

              {/* Justificativa (Comum) */}
              <div className="mb-4">
                <label className="form-label">Justificativa Técnica</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                  required
                ></textarea>
              </div>

              {/* Mensagem de Erro/Sucesso */}
              {mensagem.texto && (
                <div
                  className={`alert alert-${mensagem.tipo} p-2 text-center small mb-3`}
                >
                  {mensagem.texto}
                </div>
              )}

              {/* Botões */}
              <div className="d-grid gap-2">
                <button
                  type="submit"
                  className="btn btn-primary fw-bold"
                  disabled={loading}
                >
                  {loading ? "Enviando..." : "Confirmar Solicitação"}
                </button>
              </div>
            </form>
          </div>

          <div className="modal-footer justify-content-center bg-light border-top-0 rounded-bottom-3">
            <button
              type="button"
              className="btn btn-link text-decoration-none text-muted btn-sm"
              onClick={() => setShowHistorico(true)}
            >
              Ver Histórico de Solicitações
            </button> 
            
          </div>
        </div>
      </div>

      {/* Modal Histórico (Sobreposto) */}
      {showHistorico && (
        <ModalSolicitacoesAditivos
          projetoId={projetoId}
          onClose={() => setShowHistorico(false)}
        />
      )}
    </div>
  );
}

export default ModalSolicitarAditivo;
